import { style } from 'typestyle'
export const pr20 = style({ paddingRight: '20px' })
